module.exports = __webpack_public_path__ + "473256ddf99b12e837875aec277cfc6e.svg";